export enum SizeDropdownOptions {
  ORIGINAL = 'original',
  SMALL = 'small',
  LARGE = 'large',
  CUSTOM = 'custom',
}
